import styled from "@emotion/styled";
import { fontFredoka, theme } from "@product/scmp-sdk";

import { BaseImage } from "scmp-app/components/common/base-image";

export const Container = styled.div``;

export const Title = styled.div`
  margin-block: 32px 16px;

  color: #333333;
  font-weight: 600;
  font-size: 24px;
  font-family: ${fontFredoka};
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.01em;

  ${theme.breakpoints.up("tablet")} {
    font-size: 32px;
    line-height: 36px;
    letter-spacing: 0;
  }
`;
export const Description = styled.div`
  margin-block-end: 32px;

  color: #333333;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 22px;

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const StyledImage = styled(BaseImage)`
  inline-size: 256px;
  block-size: 165px;

  border-radius: 20px;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 420px;
    block-size: 272px;
  }
`;
